import React from 'react'
import Modal from 'react-bootstrap/Modal'

const modalTitles = {
    accepted: 'Application Successful',
    review: 'Application is under review'
}

const modalMessages = {
    accepted: 'Congratulations! Your application has been accepted. <br/> To continue, please check your email and set up your password.',
    review: 'We were unable to approve your application automatically. We will review this manually as soon as possible and will get back to you via email. This usually takes about 24 hours.'
}

const ModalOnboard = ({ isModalOpen, onModalClose, modalStatus, modalMessage }) => {
    return (
        <Modal show={isModalOpen} onHide={onModalClose}>
            <Modal.Header>
                <Modal.Title>{modalTitles[modalStatus] || ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p dangerouslySetInnerHTML={{ __html: modalMessages[modalStatus] || modalMessage }} />
            </Modal.Body>
        </Modal>
    )
}

export default ModalOnboard
